import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation, DOCUMENT } from '@angular/core'

@Component({
    selector: 'app-biometric-consent-overlay',
    templateUrl: './biometric-consent-overlay.component.html',
    styleUrls: ['./biometric-consent-overlay.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule]
})
export class BiometricConsentOverlayComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() closeOverlay = new EventEmitter<void>()
  @Output() confirmConsent = new EventEmitter<void>()
  @ViewChild('overlayContainer') overlayContainer?: ElementRef<HTMLElement>

  consentGiven = false

  constructor (
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) readonly document: any
  ) { }

  ngOnInit (): void {
    this.renderer.addClass(this.document.body, 'noScroll')
  }

  ngAfterViewInit (): void {
    // Move focus into the dialog so keyboard users land inside it and Escape-to-close works
    this.overlayContainer?.nativeElement?.focus()
  }

  toggleConsent (): void {
    this.consentGiven = !this.consentGiven
  }

  onClose (): void {
    this.closeOverlay.emit()
  }

  onConfirm (): void {
    if (!this.consentGiven) return
    this.confirmConsent.emit()
  }

  ngOnDestroy (): void {
    this.renderer.removeClass(this.document.body, 'noScroll')
  }
}
